<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <branch-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import BranchCrud from "./BranchCrud";
    export default {
        name: "Branch",
        components: {BranchCrud}
    }
</script>

<style scoped>

</style>

